import { toast } from 'react-toastify';
import { CrmAccountDetailsResponse } from '../../../../../api/types/crm/accounts/crm-account-details-response';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const getCrmAccountDetailsOperation = async (
  accountId: number,
  setDetails: (details: CrmAccountDetailsResponse | null) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getCrmAccountDetails(accountId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setDetails(res.data.body ?? null);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
